import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';

// Lazy-loaded tab containers
const InscripcionesPage = React.lazy(() => import('@/modules/school-services/inscripciones/InscripcionesPage'));
const ExpedientesPage = React.lazy(() => import('@/modules/school-services/expedientes/ExpedientesPage'));
const CertificacionPage = React.lazy(() => import('@/modules/school-services/certificacion/CertificacionPage'));
const ControlEscolarPage = React.lazy(() => import('@/modules/school-services/control-escolar/ControlEscolarPage'));
const LaunchesPage = React.lazy(() => import('@/modules/sales/launches/components/LaunchesPage'));

export const schoolServicesRoutes = [
  // Lanzamientos (directo, sin tab container)
  <Route key="/servicios-escolares/lanzamientos" path="/servicios-escolares/lanzamientos" element={
    <ProtectedRoute requiredPermission="school.launches.view"><LaunchesPage /></ProtectedRoute>
  } />,

  // Inscripciones (2 niveles + tabs)
  <Route key="/servicios-escolares/inscripciones" path="/servicios-escolares/inscripciones" element={
    <Navigate to="/servicios-escolares/inscripciones/admision" replace />
  } />,
  <Route key="/servicios-escolares/inscripciones/admision" path="/servicios-escolares/inscripciones/admision" element={
    <ProtectedRoute requiredPermission="hr.hiring.view"><InscripcionesPage /></ProtectedRoute>
  } />,
  <Route key="/servicios-escolares/inscripciones/becas-asignadas" path="/servicios-escolares/inscripciones/becas-asignadas" element={
    <InscripcionesPage />
  } />,
  <Route key="/servicios-escolares/inscripciones/reinscripciones" path="/servicios-escolares/inscripciones/reinscripciones" element={
    <InscripcionesPage />
  } />,
  <Route key="/servicios-escolares/inscripciones/cambios" path="/servicios-escolares/inscripciones/cambios" element={
    <InscripcionesPage />
  } />,
  <Route key="/servicios-escolares/inscripciones/equivalencias" path="/servicios-escolares/inscripciones/equivalencias" element={
    <InscripcionesPage />
  } />,

  // Expedientes (2 niveles + tabs)
  <Route key="/servicios-escolares/expedientes" path="/servicios-escolares/expedientes" element={
    <Navigate to="/servicios-escolares/expedientes/alumnos" replace />
  } />,
  <Route key="/servicios-escolares/expedientes/alumnos" path="/servicios-escolares/expedientes/alumnos" element={
    <ExpedientesPage />
  } />,
  <Route key="/servicios-escolares/expedientes/documentacion-oficial" path="/servicios-escolares/expedientes/documentacion-oficial" element={
    <ExpedientesPage />
  } />,
  <Route key="/servicios-escolares/expedientes/validacion" path="/servicios-escolares/expedientes/validacion" element={
    <ExpedientesPage />
  } />,
  <Route key="/servicios-escolares/expedientes/archivo-historico" path="/servicios-escolares/expedientes/archivo-historico" element={
    <ExpedientesPage />
  } />,

  // Certificación (2 niveles + tabs)
  <Route key="/servicios-escolares/certificacion" path="/servicios-escolares/certificacion" element={
    <Navigate to="/servicios-escolares/certificacion/constancias" replace />
  } />,
  <Route key="/servicios-escolares/certificacion/constancias" path="/servicios-escolares/certificacion/constancias" element={
    <CertificacionPage />
  } />,
  <Route key="/servicios-escolares/certificacion/certificados" path="/servicios-escolares/certificacion/certificados" element={
    <CertificacionPage />
  } />,
  <Route key="/servicios-escolares/certificacion/titulos-cedulas" path="/servicios-escolares/certificacion/titulos-cedulas" element={
    <CertificacionPage />
  } />,
  <Route key="/servicios-escolares/certificacion/apostillas" path="/servicios-escolares/certificacion/apostillas" element={
    <CertificacionPage />
  } />,

  // Control Escolar (2 niveles + tabs)
  <Route key="/servicios-escolares/control-escolar" path="/servicios-escolares/control-escolar" element={
    <Navigate to="/servicios-escolares/control-escolar/actas-calificaciones" replace />
  } />,
  <Route key="/servicios-escolares/control-escolar/actas-calificaciones" path="/servicios-escolares/control-escolar/actas-calificaciones" element={
    <ControlEscolarPage />
  } />,
  <Route key="/servicios-escolares/control-escolar/kardex-institucional" path="/servicios-escolares/control-escolar/kardex-institucional" element={
    <ControlEscolarPage />
  } />,
  <Route key="/servicios-escolares/control-escolar/estadisticas-matriculas" path="/servicios-escolares/control-escolar/estadisticas-matriculas" element={
    <ControlEscolarPage />
  } />,
  <Route key="/servicios-escolares/control-escolar/reportes-911" path="/servicios-escolares/control-escolar/reportes-911" element={
    <ControlEscolarPage />
  } />,
];
